<fc-promoted-label *ngIf="showPromoted" [product]="product"></fc-promoted-label>
<fc-table-image [product]="product"></fc-table-image>
<h2 *ngIf="showHeading" [innerHtml]="GetHeading()"></h2>
<fc-column-container *ngIf="columns" [columns]="columns"></fc-column-container>
<div class="fc-advertised-product-summary" [innerHtml]="product.product.summary | markedInline"></div>
<fc-apply [settings]="GetApplySettings()"></fc-apply>

